import apiHandler from "../core/apiHandler";

const cashSummaryApi = apiHandler("cash/summary");

export default cashSummaryApi;